import React, { Component } from 'react'

export class OtherDnsApp extends Component {
    componentDidMount(){
        let [url,client] = ["",localStorage.getItem('client')];
        if(window.location.pathname === '/plannerApp') {
            url = client === "SWISS" || client === "POLAND" ? 'https://termin.drivenscan.app/' : 'https://planner.drivenscan.app/'
        } else if(window.location.pathname === '/workshopApp') {
            url = 'https://workshop.drivenscan.app/'
        }
        var a = document.createElement('a');
        a.target = '_blank';
        a.href = url;
        a.click()
        window.location.pathname='/dashboard'
    }
  render() {
    return (
      <></>
    )
  }
}

export default OtherDnsApp